import React from 'react';
import { TextInputField } from '../../../../../shared/form/inputs/TextInputField';
import { roomFieldName } from '../../quoteOrDesignFormFieldNameHelpers';
import { RoomFormModel } from '../roomFormModel';

type Props = {
  unitIndex: number;
  manifoldIndex: number;
  roomIndex: number;
  room: RoomFormModel;
};

export const RoomPerimeterField = ({ unitIndex, manifoldIndex, roomIndex, room }: Props) => {
  if (room.floorConstruction == null || !room.floorConstruction.isSkirtingHeating) {
    return null;
  }

  return (
    <TextInputField
      name={roomFieldName(unitIndex, manifoldIndex, roomIndex, 'perimeterInMetres')}
      label="Perimeter (m)"
    />
  );
};
